var _path, _rect, _rect2, _path2, _text, _rect3, _rect4, _rect5, _rect6, _rect7, _text2, _rect8, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebhookPaymentOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1528,
    height: 496,
    viewBox: "0 0 1528 496",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.327 14.327 0 32 0H1496C1513.67 0 1528 14.327 1528 32V496H0V32Z",
    fill: "#F9D9A8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 68,
    width: 812,
    height: 460,
    rx: 12,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 108,
    width: 68,
    height: 68,
    rx: 4,
    fill: "#E8FBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414 142L426 154L450 130",
    stroke: "#00A651",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 398,
    y: 250,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fill: "#1F1F1F"
  }, "Payment Order event")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 300,
    width: 728,
    height: 34,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 356,
    width: 560,
    height: 28,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 402,
    width: 420,
    height: 28,
    fill: "#F3F3F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 112,
    width: 502,
    height: 140,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#E2E2E2",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 140,
    width: 96,
    height: 32,
    rx: 6,
    fill: "#186FAF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 890,
    y: 163,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "POST")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 988,
    y: 144,
    width: 250,
    height: 24,
    fill: "#F0F0F0"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 878,
    y: 222,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fill: "#1F1F1F"
  }, "200 OK")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhookPaymentOrder);
export default __webpack_public_path__ + "static/media/webhook-payment-order.3755d886001becc70524cf7c5473ec85.svg";
export { ForwardRef as ReactComponent };